export function exitGame(): void {
  if (typeof window === 'undefined') return;

  const showClosedState = (): void => {
    if (window.closed) return;
    document.body.innerHTML = `
      <main id="exit-screen" style="min-height:100vh;display:grid;place-items:center;background:#07090d;color:#c8d4e0;font-family:Consolas,Menlo,monospace;text-align:center;padding:24px">
        <section style="border:1px solid #2a5266;border-radius:8px;padding:32px;max-width:420px;background:#0e141a;box-shadow:0 20px 60px rgba(0,0,0,.45)">
          <p style="margin:0 0 10px;color:#5ec8ff;letter-spacing:.12em">SESSION CLOSED</p>
          <h1 style="margin:0 0 14px;font-size:22px">APOGEE HOLD</h1>
          <p style="margin:0;color:#7ea0b1;font-size:12px;line-height:1.6">You can close this browser tab.</p>
        </section>
      </main>`;
  };

  if (window.opener) {
    window.close();
    window.setTimeout(showClosedState, 120);
  } else {
    showClosedState();
  }
}
